module.exports = "../images/fishing-lodge-3-28.jpg?v=8e0dd84";